// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@bg/MobiusOverrides/Button/Props";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

export interface ProductsStickyFooterStyles {
    container?: InjectableCss;
    InfoSectionWrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
    totalText?: TypographyPresentationProps;
    summaryButton?: ButtonPresentationProps;
}

export const productsStickyFooterStyles: ProductsStickyFooterStyles = {};

const styles = productsStickyFooterStyles;

const ProductsStickyFooter = () => {
    const { itemCount, totalPrice } = useAppSelector(state => {
        const { cartId } = state.pages.onePageCheckout;
        const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
        return {
            itemCount: cartState.value?.totalCountDisplay,
            totalPrice: cartState.value?.orderGrandTotalDisplay,
        };
    });

    const scrollToSummarySection = () => {
        const element = document.getElementById("onePageCheckout_SummarySectionContainer");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });
        }
    };

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.InfoSectionWrapper}>
                <StyledWrapper {...styles.innerWrapper}>
                    <Typography {...styles.labelText}>{translate("Products")}</Typography>
                    <Typography {...styles.valueText}>{itemCount}</Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.innerWrapper}>
                    <Typography {...styles.labelText}>{translate("Total")}</Typography>
                    <Typography {...styles.valueText}>{totalPrice}</Typography>
                </StyledWrapper>
            </StyledWrapper>
            <Button {...styles.summaryButton} onClick={scrollToSummarySection}>
                {translate("View Order Summary")}
            </Button>
        </StyledWrapper>
    );
};

export default ProductsStickyFooter;
